import { ADICIONA_REMOVE_IMAGENS_ENCOMENDA } from '../../actions/types'

const initialState = {
  arquivos: []
}

export default function (state = initialState, action) {
  switch (action.type) {

    case ADICIONA_REMOVE_IMAGENS_ENCOMENDA: {
      const arquivos = action.payload;
      return {
        ...state,
        arquivos
      }
    }

    default:
      return state
  }
}
